import React, { useState } from "react";
import { TextField, MenuItem, Button, Box, Typography, Alert } from "@mui/material";

const categories = [
  "Bus delayed",
  "Breakdown",
  "Accident",
  "Road Block/Landslide",
  "Lost & Found",
  "Bad Behaviour",
  "Other",
];

export default function ReportIssue() {
  const [data, setData] = useState({ category: "", busNumber: "", description: "" });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => setData({ ...data, [e.target.name]: e.target.value });

  const handleSubmit = () => {
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 3000);
    setData({ category: "", busNumber: "", description: "" });
  };

  return (
    <Box sx={{ maxWidth: 400 }}>
      <Typography variant="h5" gutterBottom>
        Report an Issue
      </Typography>
      <TextField
        select
        label="Category"
        name="category"
        value={data.category}
        onChange={handleChange}
        fullWidth
        sx={{ mb: 2 }}
      >
        {categories.map((cat) => (
          <MenuItem key={cat} value={cat}>
            {cat}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        label="Bus Number / Road"
        name="busNumber"
        value={data.busNumber}
        onChange={handleChange}
        fullWidth
        sx={{ mb: 2 }}
      />
      <TextField
        label="Description"
        name="description"
        value={data.description}
        onChange={handleChange}
        multiline
        rows={3}
        fullWidth
        sx={{ mb: 2 }}
      />
      <Button variant="contained" onClick={handleSubmit}>
        Submit
      </Button>
      {submitted && (
        <Alert sx={{ mt: 2 }} severity="success">
          Issue reported! Thank you.
        </Alert>
      )}
    </Box>
  );
}

